import { render, staticRenderFns } from "./LotTypeSelection.vue?vue&type=template&id=33fda84b&scoped=true"
import script from "./LotTypeSelection.vue?vue&type=script&lang=js"
export * from "./LotTypeSelection.vue?vue&type=script&lang=js"
import style0 from "./LotTypeSelection.vue?vue&type=style&index=0&id=33fda84b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_ckru7f3yypsoan6edyu23zfbiq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fda84b",
  null
  
)

export default component.exports